import { debounce as c } from "lodash-es";
import { S as a } from "./errors-YTprc4A2.mjs";
function i(o = { behavior: "smooth", left: 0, top: 100 }) {
  try {
    window.scrollTo(o);
  } catch {
    window.scrollTo(0, 0);
  }
}
const l = (o) => {
  const e = o == null ? void 0 : o.getBoundingClientRect();
  return {
    left: ((e == null ? void 0 : e.left) || 0) + (window == null ? void 0 : window.scrollX),
    top: ((e == null ? void 0 : e.top) || 0) + (window == null ? void 0 : window.scrollY)
  };
};
function u() {
  const o = document.querySelector("*[aria-invalid=true]");
  if (o !== null) {
    const t = document.querySelector(
      `*[id="${o.getAttribute("aria-labelledby")}"]`
    ) || o, n = l(t);
    window.scrollTo({ top: n.top, left: n.left, behavior: "smooth" });
  }
}
const h = () => {
  const o = window == null ? void 0 : window.location;
  if (!o)
    throw new a("Unable to retireve the window.location object");
  const { protocol: e, port: t } = o;
  return e.concat("//").concat(`${o.hostname}:${t}`);
}, m = (o, e) => {
  const t = (n) => n.replace(/^#/, "").toLowerCase();
  return t(o) === t(e);
};
function d(o, e = 2) {
  if (o === 0)
    return "0 Bytes";
  const t = 1024, n = e < 0 ? 0 : e, s = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], r = Math.floor(Math.log(o) / Math.log(t));
  return parseFloat((o / Math.pow(t, r)).toFixed(n)) + " " + s[r];
}
const w = console.log, f = console.warn, b = console.error, g = (o, e) => {
  const t = c((n, s, r) => {
    o(...r).then(n).catch(s);
  }, e);
  return (...n) => new Promise((s, r) => {
    t(s, r, n);
  });
};
function p() {
  var t;
  return new URLSearchParams(window.location.search).get("channel") === "mobileApplication" && (document.cookie = "mobileChannel=1"), (t = document.cookie) == null ? void 0 : t.includes("mobileChannel=1");
}
const y = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  debounceAsync: g,
  errorMessage: b,
  formatBytes: d,
  getDomainUrl: h,
  getElementOffset: l,
  isAnchorEqual: m,
  isMobileWebview: p,
  logMessage: w,
  scrollTo: i,
  scrollToError: u,
  warnMessage: f
}, Symbol.toStringTag, { value: "Module" }));
export {
  i as a,
  m as b,
  l as c,
  g as d,
  b as e,
  d as f,
  h as g,
  y as h,
  p as i,
  w as l,
  u as s,
  f as w
};
